// extracted by mini-css-extract-plugin
module.exports = {"page":"Auth_page__1dgLw","left":"Auth_left__2Q8SW","right":"Auth_right__151-C"};